import { Share } from "@capacitor/share";
import { isNativeApp } from "./platform";
import { withExternalFlow } from "../features/themes/externalFlow";
import logger from "./logger";

// La pagina che manda allo store giusto (StoreLanding).
export const SITO_PUZZLY = "https://puzzly.giadalabs.com";

// Apre il foglio di condivisione del telefono. La WebView di Android non ha
// navigator.share (crbug.com/40540400), quindi nell'app passa dal plugin nativo;
// sul web resta navigator.share. Torna false solo se non c'è modo di condividere,
// così chi chiama può ripiegare sul copiare il link.
export async function condividi({ title, text, url }) {
  try {
    if (isNativeApp()) {
      // Android attacca l'url in fondo al testo: se il testo lo contiene già, non lo ripete.
      const urlAParte = url && !(text && text.includes(url)) ? url : undefined;
      await withExternalFlow(() => Share.share({ title, text, url: urlAParte, dialogTitle: title }));
      return true;
    }
    if (typeof navigator !== "undefined" && navigator.share) {
      await withExternalFlow(() => navigator.share({ title, text, url }));
      return true;
    }
  } catch (err) {
    // Chiudere il foglio senza scegliere un'app arriva qui: non è un errore.
    logger.info("share sheet closed", { error: err && err.message });
    return true;
  }
  return false;
}

// #125: una frase e il link al sito.
export function consigliaPuzzly(t) {
  return condividi({ title: t("common.account.recommend"), text: t("common.account.recommendText"), url: SITO_PUZZLY });
}
